// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3oxKG","content":"LoadingAlert_content__1JgXp"};